import * as React from 'react';
import { Providers } from 'Providers';
import { ErrorBoundary } from 'components/ErrorBoundary/ErrorBoundary';
// CSS IMPORTS
import './styles/App.css';
import './styles/font-overrides.css';
import './styles/menu-overrides.css';
import 'flexboxgrid';

/**
 * Main app component, sets up the router for different pages in the App
 * Includes global error boundary to catch unhandled React errors
 *
 * GoogleMapsProvider is initialized in the Providers component for React 18 compatibility
 * and test availability. All map components (EntitiesMap, EnhancedEntityMap) use this.
 */
const App = () => {
  return (
    <ErrorBoundary>
      <Providers />
    </ErrorBoundary>
  );
};

export default App;
